<template>
  <div
    class="quincy-wrapper__controls__rotate-button"
    @click="toggleActionStates"
    @dblclick="$RESETCAMERA()"
    :class="activeClass"
    ref="toolbar"
    v-show="visible"
    v-tippy="{ placement: 'right', content: $t('components.quincy.buttons.rotate') }"
    data-cy="quincy-controls-camera"
  >
    <move-vue :selected="cameraActive"></move-vue>
  </div>
</template>

<script>
import core from '../../store/quincy/core';
import { mapGetters, mapMutations } from 'vuex';
import { MUTATIONS, GETTERS } from '../../store/quincy/definitions';
import MoveVue from './controls/Move.vue';

export default {
  components: {
    MoveVue
  },
  data() {
    return {
      visible: true
    };
  },
  mounted() {
    // document
    //   .querySelector('.content')
    //   .addEventListener('scroll', this.scroll, false);
  },
  unmounted() {
    // document
    //   .querySelector('.content')
    //   .removeEventListener('scroll', this.scroll, false);
  },
  methods: {
    ...mapMutations('quincy', {
      $TOGGLECONTROLS: MUTATIONS.TOGGLE_CONTROLS,
      $RESETCAMERA: MUTATIONS.RESET_CAMERA
    }),
    toggleActionStates() {
      this.$TOGGLECONTROLS({ camera: !this.cameraActive });
    },
    scroll(e) {
      if (
        document.querySelector('.content').scrollTop + 40 <
        document.querySelector('.quincy-wrapper').offsetHeight
      ) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    }
  },
  computed: {
    ...mapGetters('quincy', {
      $SETTINGS: GETTERS.SETTINGS
    }),
    cameraActive() {
      return this.$SETTINGS.controls.camera;
    },
    enabledState() {
      return this.cameraActive || false;
    },
    activeClass() {
      return this.cameraActive !== true
        ? ''
        : 'quincy-wrapper__controls__rotate-button--active';
    }
  }
};
</script>
